
import { UseControllerProps, useFormContext } from "react-hook-form";

import Textarea from "../../../../common/components/form/Textarea";

const ServiceOrderingInformationsForm: React.FC<UseControllerProps> = ({
  name,
}) => {
  const { control } = useFormContext();
  return (
    <div className="d-flex flex-column gap-3">
      <span className="serviceOrdering-subtitle">
        Informations complémentaires
      </span>
      <Textarea control={control} name={name} />
    </div>
  );
};

export default ServiceOrderingInformationsForm;
